// extracted by mini-css-extract-plugin
export default {"maincontainer":"User_maincontainer__GNOcT","header":"User_header__sBkWv","btn_color":"User_btn_color__0yyVG","btn_colordis":"User_btn_colordis__VAIZn","holder":"User_holder__sdcKu"};